/**
 * Ответы методов метрик (AdminService.GetMetricsOverview и GetRequestMetrics).
 *
 * int64 из gRPC-Gateway приходят строками — их приводит к числам num().
 */

type Int64 = string | number;

export interface DailyMetrics {
  date: string;
  signups: Int64;
  uniqueVisitors: Int64;
  visits: Int64;
  gamesStarted: Int64;
  gamesFinished: Int64;
  guesses: Int64;
  activePlayers: Int64;
  deletionRequests: Int64;
}

export interface MetricsOverview {
  timezone: string;
  from: string;
  to: string;
  users: { total: Int64; newInPeriod: Int64; verified: Int64; blocked: Int64 };
  activity: { dau: Int64; wau: Int64; mau: Int64 };
  visits: { uniqueVisitors: Int64; visits: Int64; uniqueToday: Int64 };
  games: {
    started: Int64;
    finished: Int64;
    solo: Int64;
    multiplayer: Int64;
    guesses: Int64;
    avgGuessScore: number;
    roomsCreated: Int64;
    avgMultiplayerPlayers: number;
  };
  content: { publishedPhotos: Int64; publishedQuests: Int64; pendingQuests: Int64; newFeedback: Int64 };
  funnel: { visitors: Int64; signups: Int64; verified: Int64; played: Int64 };
  daily: DailyMetrics[];
  topQuests: {
    questId: string;
    title: string;
    games: Int64;
    finished: Int64;
    players: Int64;
    avgScore: number;
  }[];
  sources: { source: string; visitors: Int64 }[];
  deletions: { requested: Int64; canceled: Int64; completed: Int64; pending: Int64 };
}

export interface RequestStats {
  count: Int64;
  rps: number;
  avgMs: number;
  p50Ms: number;
  p95Ms: number;
  p99Ms: number;
  maxMs: number;
  serverErrors: Int64;
  clientErrors: Int64;
}

export interface RequestMetrics {
  stepSeconds: number;
  total: RequestStats;
  series: {
    time: string;
    count: Int64;
    rps: number;
    avgMs: number;
    p95Ms: number;
    serverErrors: Int64;
  }[];
  methods: { method: string; stats: RequestStats }[];
}

export const num = (value: Int64 | undefined | null): number => Number(value ?? 0);
